export const BUTTON_STYLE_TYPE = {
  GENERAL: 'general',
  ERROR: 'error'
}

export const BUTTON_CLASS_BY_BUTTON_STYLE_TYPE = {
  [BUTTON_STYLE_TYPE.GENERAL]: 'main-button__btn--general',
  [BUTTON_STYLE_TYPE.ERROR]: 'main-button__btn--error'
}
